'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = outsideTargetHandlerFactory;

var _isDOMEquals = require('./isDOMEquals');

var _isDOMEquals2 = _interopRequireDefault(_isDOMEquals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * @param  {HTMLElement}  targetNode
 * @param  {HTMLElement}  eventHandler
 * @return {Boolean}
 */
function outsideTargetHandlerFactory(targetNode, eventHandler) {
  return function (evt) {
    evt.stopPropagation();
    var current = evt.target;
    var found = false;
    while (current.parentNode) {
      found = (0, _isDOMEquals2.default)(current, targetNode);
      if (found) return;
      current = current.parentNode;
    }
    eventHandler(evt);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/sweetalert-react/lib/utils/outsideTargetHandlerFactory.js
// module id = 2546
// module chunks = 0